import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

interface SelectorProps {
    data: any[],
    value?: string,
    placeholder: string,
    handleChange: ((e: React.ChangeEvent<HTMLInputElement>) => void),
    identifier: string
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        formControl: {
            margin: theme.spacing(1),
            minWidth: 120,
        },
        selectEmpty: {
            marginTop: theme.spacing(2),
        },
    }),
);

const Selector: React.FC<SelectorProps> = ({ data, identifier, placeholder, value, handleChange }) => {

    const classes = useStyles();
    return (
        <FormControl className={classes.formControl}>
            <InputLabel id="demo-simple-select-label">{placeholder}</InputLabel>
            <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={value}
                //@ts-ignore
                onChange={(e) => { handleChange(e) }}
                defaultValue={'-1'}
            >
                <MenuItem value={'-1'}>Selecione</MenuItem>
                {
                    data.map((item: any) => (
                        <MenuItem
                            key={item.id}
                            value={item.id}>{item[identifier]}</MenuItem>
                    ))
                }
            </Select>
        </FormControl>
    )
}

export default Selector